export default __webpack_public_path__ + "f9f4a05e489772a6b9ab12e703d4660d.svg";